import {
  LEGAL_REACCEPTANCE_TERMS_WALLET_WIZARD_BODY,
  LEGAL_REACCEPTANCE_TERMS_WALLET_WIZARD_CONFIRM_CTA
} from 'containers/legal-reacceptance/constants';
import { LegalReacceptanceContent } from 'containers/legal-reacceptance/legalReacceptance.model';

export const mergeWalletWizardTermsContent = (content: LegalReacceptanceContent): LegalReacceptanceContent => ({
  ...content,
  body: LEGAL_REACCEPTANCE_TERMS_WALLET_WIZARD_BODY,
  confirmButtonText: LEGAL_REACCEPTANCE_TERMS_WALLET_WIZARD_CONFIRM_CTA
});
